/**
 * 产品页布局修复 - 将数量选择器移到尺寸旁边
 * 解决 CSS 无法实现的 web component 内部结构问题
 */

(function() {
  'use strict';

  // container: 要處理的根節點（document 或 modal 元素）
  // 自動把數量選擇器移到尺寸選項旁邊（同一行）
  function fixQuantityPositionIn(container) {
    container = container || document;

    // 找到 variant-picker（用 closest 定位相同 product-info 範圍）
    var variantPicker = container.querySelector('.variant-picker');
    if (!variantPicker) return false;

    // 找到所有尺寸/顏色 option fieldset
    var fieldsets = variantPicker.querySelectorAll('.variant-picker__option');
    if (fieldsets.length < 2) return false;

    var sizeFieldset = fieldsets[1]; // 第二個 = Size

    // 使用 data-block-type (Prestige: block.type | replace: '_', '-')
    var quantityBlock = container.querySelector('[data-block-type="quantity-selector"]');
    if (!quantityBlock) return false;

    // 已經處理過則跳過
    if (container.querySelector && container.querySelector('.sqw-done')) return true;

    // 建立 flex 包裝容器，讓 Size 和 Quantity 同行
    var wrapper = document.createElement('div');
    wrapper.className = 'sqw-done';
    wrapper.style.cssText = 'display:flex!important;gap:8px!important;width:100%!important;align-items:flex-end!important;margin-bottom:8px!important;';

    // Size 佔 60%
    sizeFieldset.style.cssText = 'flex:1 1 60%!important;min-width:0!important;margin-bottom:0!important;';

    // Quantity 靠右，不讓 label "數量" 太高
    quantityBlock.style.cssText = 'flex:0 0 auto!important;margin-bottom:0!important;display:block!important;';
    var qInner = quantityBlock.querySelector('.v-stack, quantity-selector');
    if (qInner) {
      qInner.style.cssText = 'display:flex!important;flex-direction:column!important;align-items:flex-end!important;';
    }

    // 插入 wrapper 到 variant-picker 後面
    variantPicker.parentNode.insertBefore(wrapper, variantPicker.nextSibling);
    wrapper.appendChild(sizeFieldset);
    wrapper.appendChild(quantityBlock);

    return true;
  }

  function fixQuantityPosition() {
    if (window.innerWidth >= 750) return fixQuantityPositionIn(document);
    return fixQuantityPositionIn(document);
  }

// 尺寸排序：S → M → L → XL → 2L → 2L/XXL → XXL → 3L
  var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', '2L', '2L/XXL', 'XXL', '2XL', '3L', '3XL'];

  function getOptionValue(el) {
    // 如果 el 本身就是 input，直接讀 value
    if (el.nodeName === 'INPUT') return el.value.trim().toUpperCase();
    // 尋找內部 input
    var inp = el.querySelector('input[type="radio"], input[type="checkbox"]');
    if (inp) return inp.value.trim().toUpperCase();
    // 尋找 label 文字
    var lbl = el.querySelector('label, .block-swatch__label');
    if (lbl) return lbl.textContent.trim().toUpperCase();
    return el.textContent.trim().toUpperCase();
  }

  function reorderSizesIn(root) {
    // 用 CSS order 屬性排序，不移動 DOM（保留事件監聽器和選取狀態）
    var allOptionValues = (root || document).querySelectorAll('.variant-picker__option-values');
    allOptionValues.forEach(function(container) {
      var items = Array.from(container.children);
      if (items.length < 2) return;
      // 確認是尺寸選項（至少一個值在 SIZE_ORDER 裡）
      var hasSizeVal = items.some(function(item) {
        var v = getOptionValue(item);
        return v !== '' && SIZE_ORDER.indexOf(v) !== -1;
      });
      if (!hasSizeVal) return;
      // 設每個項目的 CSS order（input 和 label 取同一個值，保持相鄰）
      items.forEach(function(item) {
        var val = getOptionValue(item);
        var idx = SIZE_ORDER.indexOf(val);
        item.style.order = (idx !== -1) ? idx : 99;
      });
    });
  }

  function reorderSizes() { reorderSizesIn(document); }

  // 監聽 quick-buy modal 動態載入（尺寸排序 + 數量移到尺寸旁）
  var _modalObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        var isModal = node.classList && (
          node.classList.contains('quick-buy-modal') ||
          (node.querySelector && node.querySelector('.variant-picker__option-values'))
        );
        if (isModal) {
          setTimeout(function() {
            reorderSizesIn(node);
            fixQuantityPositionIn(node);
          }, 120);
        }
      });
    });
  });
  _modalObserver.observe(document.body, { childList: true, subtree: true });

  // 隱藏「尺寸指南」分頁（保留其他 tabs）
  function hideSizeGuideTab() {
    // 支援 collapsible-tab-group（Prestige 主題）和一般 tab 結構
    var allTabs = document.querySelectorAll(
      'collapsible-tab, .product-tabs__tab, [role="tab"], .tab-item, details'
    );

    allTabs.forEach(function(tab) {
      var label = tab.querySelector('summary, button, .tab-label, legend') || tab;
      if (label && label.textContent.trim().indexOf('尺寸指南') !== -1) {
        // 隱藏整個 tab 元素（包含 summary 和內容）
        tab.style.display = 'none';
      }
    });

    // 也嘗試隱藏 nav 裡的 tab 按鈕
    var navButtons = document.querySelectorAll('.product-tabs__nav button, .product-tabs__nav a, .tabs__nav button');
    navButtons.forEach(function(btn) {
      if (btn.textContent.trim().indexOf('尺寸指南') !== -1) {
        btn.style.display = 'none';
        // 如果這個按鈕是 active，自動切換到下一個
        if (btn.classList.contains('active') || btn.getAttribute('aria-selected') === 'true') {
          var next = btn.parentElement.querySelector('button:not([style*="none"]), a:not([style*="none"])');
          if (next) next.click();
        }
      }
    });

    // 隱藏對應的 panel（如果有 aria-labelledby 或 data-index）
    var panels = document.querySelectorAll('.product-tabs__panel, [role="tabpanel"]');
    panels.forEach(function(panel) {
      if (panel.textContent.trim().indexOf('尺寸指南') !== -1 ||
          panel.textContent.trim().indexOf('尺寸對照') !== -1) {
        panel.style.display = 'none';
      }
    });
  }

  // 尝试执行修复
  let attemptCount = 0;
  const maxAttempts = 50;

  function attemptFix() {
    attemptCount++;

    reorderSizes();
    hideSizeGuideTab();

    if (fixQuantityPosition()) {
      // 修復成功
    } else if (attemptCount < maxAttempts) {
      setTimeout(attemptFix, 100);
    }
  }

  // DOM 加载完成后执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attemptFix);
  } else {
    attemptFix();
  }

  // 监听 Shopify 主题编辑器刷新
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      attemptCount = 0;
      attemptFix();
    });
  }
})();
